import appManagement from './appManagement';
import customerManagement from './customerMangement';
import dashboard from './dashboard';
import farmManagement from './farmManagement';
import formManagement from './formManagement';
import labManagement from './labManagement';
import reportManagement from './reportManagement';
import userManagement from './userManagement';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [dashboard, formManagement, farmManagement, userManagement, customerManagement, reportManagement, appManagement]
};
const labMenuItems = {
    // items: [dashboard, labManagement]
    items: [labManagement]
};

const userMenuItems = {
    items: [dashboard, farmManagement, appManagement]

}

export { menuItems, labMenuItems, userMenuItems };
